<template>
    <user-form :edit-mode="true"/>
</template>

<script>
    import UserForm from '../../components/UserForm'

    export default {
        components: {
            UserForm
        }
    }
</script>
